import CustomDialog from "components/CustomDialog";
import ProductImages from "pages/products/ProductImages";
import React from "react";

const ProductImageInDialog = ({ open, handleClose, product }) => {
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading={
        product.images.length > 0
          ? "Update product images"
          : "Add product images"
      }
    >
      <ProductImages product={product} fullGrid={true} />
    </CustomDialog>
  );
};

export default ProductImageInDialog;
